import { UserFragment, useInviteUserMutation } from "@graphql/users/users.g";
import { toast } from "react-toastify";

import { UserForm, UserFormValues } from "@components/Forms/UserForm/UserForm";

type Props = {
  onInviteUserSuccess?: (data: UserFragment) => Promise<void> | void;
};

export const CreateUserForm = ({ onInviteUserSuccess }: Props) => {
  const inviteUserMutation = useInviteUserMutation();
  const inviteUser = inviteUserMutation.mutateAsync;

  const onSubmit = async (values: UserFormValues) => {
    const data = await inviteUser({
      input: {
        ...values,
      },
    });

    const user = data?.inviteUser?.user;

    if (!user) return;

    toast.success("User invited successfully");

    await onInviteUserSuccess?.(user);
  };

  return <UserForm onSubmit={onSubmit} />;
};
